import React from 'react';
import PDF from 'react-pdf-js';

class MyPdfViewer extends React.Component {
  state = {};

  onDocumentComplete = (pages) => {
    this.setState({ page: 1, pages });
  }

  onPageComplete = (page) => {
    this.setState({ page });
  }

  handlePrevious = () => {
    this.setState({ page: this.state.page - 1 });
  }

  handleNext = () => {
    this.setState({ page: this.state.page + 1 });
  }

  renderPagination = (page, pages) => {
    let previousButton = <li className="previous" onClick={this.handlePrevious}><a><i className="fa fa-arrow-left"></i> 上一页</a></li>;
    if (page === 1) {
      previousButton = <li className="previous disabled"><a><i className="fa fa-arrow-left"></i>上一页</a></li>;
    }
    let nextButton = <li className="next" onClick={this.handleNext}><a>下一页 <i className="fa fa-arrow-right"></i></a></li>;
    if (page === pages) {
      nextButton = <li className="next disabled"><a>下一页 <i className="fa fa-arrow-right"></i></a></li>;
    }
    let backButton = <li onClick={this.props.onBack}><a>返回<i className="fa fa-arrow-right"></i></a></li>;
    return (
      <nav>
        <ul className="pager">
          {previousButton}
          {nextButton}
          {backButton}
        </ul>
      </nav>
    );
  }

  render() {
    let pagination = null;
    if (this.state.pages) {
      pagination = this.renderPagination(this.state.page, this.state.pages);
    }
    return (
      <div style={{ WebkitOverflowScrolling: 'touch', overflow: 'scroll', width: '100%', height: '100%' }}>
        <PDF
          file={this.props.url}
          onDocumentComplete={this.onDocumentComplete}
          onPageComplete={this.onPageComplete}
          page={this.state.page}
        />
        {pagination}
      </div>
    )
  }
}

export default MyPdfViewer